"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUD_READS = exports.CRUD_EVENTS = exports.CRUD_COMMANDS = void 0;
/**
 * Набор команд и событий CRUD-сущности (ROENT).
 *
 * Чтения (`get`/`list`/`aggregate`) есть у сущности всегда. Команды записи и
 * события объявляются явно: проекция фактов (CDR, аналитика) не принимает
 * записи через шину, и объявить `cmd.<e>.create` без ответчика — ложное
 * обещание в реестре, discovery и каталоге прав. Отсутствующая операция —
 * отсутствующий ключ в `routes`, а не заглушка-отказ в handler'е.
 *
 * Команды и события независимы: у CDR нет `create`-команды, но есть настоящий
 * `created`-факт (строка появилась, её записал коллектор).
 */
exports.CRUD_COMMANDS = ['create', 'update', 'delete'];
exports.CRUD_EVENTS = ['created', 'updated', 'deleted'];
/** Чтения сущности — обязательны в любом наборе. */
exports.CRUD_READS = ['get', 'list', 'aggregate'];
//# sourceMappingURL=entity-ops.js.map